var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.Visible)?_c('div',{staticClass:"message_warpper",style:(_vm.style)},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.Title))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.Content))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }